import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navigationItems = [
  {
    path: '/homepage',
    label: 'Beranda',
    icon: 'Home',
  },

  // MENU UTAMA → PRODUK (gantinya Motor Honda)
  {
    path: '/produk',
    label: 'Produk',
    hasDropdown: true, // nanti dipakai buat nempel dropdown
  },

  {
    path: '/credit-simulation',
    label: 'Simulasi Kredit',
    icon: 'Calculator',
  },

  {
    path: '/service-booking',
    label: 'Booking Service',
    icon: 'Wrench',
  },

  // ===== ISI DROPDOWN (PAKAI LOGIC isMore YANG LAMA) =====
  {
    path: '/produk/motor',
    label: 'Motor',
    icon: 'Bike',
    isMore: true,
  },
  {
    path: '/produk/suku-cadang',
    label: 'Suku Cadang',
    icon: 'Package',
    isMore: true,
  },
  {
    path: '/produk/oli',
    label: 'Oli',
    icon: 'Droplet',
    isMore: true,
  },
  {
    path: '/produk/apparel-aksesoris',
    label: 'Apparel & Aksesoris',
    icon: 'Shirt',
    isMore: true,
  },

  // MENU BIASA (BUKAN DROPDOWN)
  {
    path: '/contact',
    label: 'Kontak',
    icon: 'Phone',
  },
  {
    path: '/promo',
    label: 'Promo',
    icon: 'Tag', // icon PALING COCOK untuk promo
  },

];


  const primaryNav = navigationItems?.filter(item => !item?.isMore);
  const moreNav = navigationItems?.filter(item => item?.isMore);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header 
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-card shadow-md' : 'bg-card'
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20 lg:h-24">
            <Link
              to="/homepage"
              className="flex items-center gap-3 hover:opacity-80 transition-opacity"
              onClick={closeMobileMenu}>
        
              <img
                src="/assets/logo/logoberdikari.webp"
                alt="Honda Logo"
                className="h-20 lg:h-20 w-auto object-contain"/>

              <div className="flex flex-col">
                <span className="text-xl font-heading font-bold leading-tight">
                  Honda Berdikari 
                </span>
                <span className="text-sm text-muted-foreground font-medium">
                  Dealer & Ahass Resmi
                </span>
              </div>
            </Link>



          <nav className="hidden lg:flex items-center space-x-1">
            {primaryNav.map((item) => {
              // ===== PRODUK (PUNYA DROPDOWN) =====
              if (item.hasDropdown) {
                return (
                  <div key={item.label} className="relative group">
                    {/* PRODUK - NON KLIK */}
                    <button
                      type="button"
                      className={`px-4 py-2 rounded-lg font-heading font-semibold text-sm flex items-center gap-2 transition-all cursor-default ${
                        location.pathname.startsWith('/produk')
                          ? 'bg-primary text-primary-foreground'
                          : 'hover:bg-muted hover:text-primary'
                      }`}
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span>{item.label}</span>
                      <Icon name="ChevronDown" size={16} />
                    </button>

                    {/* DROPDOWN PRODUK */}
                    <div className="absolute left-0 top-full mt-2 w-56 bg-card rounded-lg shadow-card-hover opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300">
                      <div className="py-2">
                        {moreNav.map((sub) => (
                          <Link
                            key={sub.path}
                            to={sub.path}
                            className={`flex items-center gap-3 px-4 py-3 transition-colors ${
                              isActivePath(sub.path)
                                ? 'bg-primary text-primary-foreground'
                                : 'hover:bg-muted hover:text-primary'
                            }`}
                          >
                            <Icon name={sub.icon} size={18} />
                            <span className="font-heading font-semibold text-sm">
                              {sub.label}
                            </span>
                          </Link>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }


              // ===== MENU BIASA =====
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg font-heading font-semibold text-sm flex items-center gap-2 transition-all ${
                    isActivePath(item.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'hover:bg-muted hover:text-primary'
                  }`}
                >
                  <Icon name={item.icon} size={18} />
                  <span>{item.label}</span>
                </Link>
              );
            })}
          </nav>


            <div className="hidden lg:flex items-center gap-4">
              {/* LOGO HUBUNGI */}
              <img
                src="/assets/logo/logoartha.webp"
                alt="Hubungi Kami"
                className="h-20 w-auto object-contain"
              />

              {/* LOGO KONSULTASI */}
              <img
                src="/assets/logo/logoHonda.webp"
                alt="Konsultasi"
                className="h-20 w-auto object-contain"
              />
            </div>

            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 rounded-lg hover:bg-muted transition-colors"
              aria-label="Toggle mobile menu"
            >
              <Icon 
                name={isMobileMenuOpen ? 'X' : 'Menu'} 
                size={24} 
                color="var(--color-foreground)" 
              />
            </button>
          </div>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-background z-40 lg:hidden"
          style={{ top: '64px' }}
        >
          <nav className="flex flex-col h-full overflow-y-auto">
            <div className="flex-1 px-4 py-6 space-y-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-4 rounded-lg font-heading font-semibold transition-all duration-300 ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground shadow-honda-subtle'
                      : 'text-foreground hover:bg-muted hover:text-primary'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </Link>
              ))}
            </div>

            <div className="border-t border-border p-4 space-y-3">
              <Button
                variant="outline"
                size="lg"
                fullWidth
                iconName="Phone"
                iconPosition="left"
                onClick={() => {
                  window.open('https://wa.me/6281234567890', '_blank');
                  closeMobileMenu();
                }}
                className="font-heading"
              >
                Hubungi Kami
              </Button>
              <Button
                variant="default"
                size="lg"
                fullWidth
                iconName="MessageCircle"
                iconPosition="left"
                onClick={() => {
                  window.open('https://wa.me/6281234567890', '_blank');
                  closeMobileMenu();
                }}
                className="font-heading shadow-honda-subtle"
              >
                Konsultasi Sekarang
              </Button>
            </div>
          </nav>
        </div>
      )}
      <div className="h-16 lg:h-20" />
    </>
  );
};

export default Header;